import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";

export default function CTA() {
  const navigate = useNavigate();
  const [flash, setFlash] = useState(false);

  const handleBook = (e) => {
    e.preventDefault();
    setFlash(true);
    setTimeout(() => navigate("/book"), 380);
  };

  return (
    <section
      className="relative section"
      data-testid="cta-section"
    >
      {/* Top + bottom radial glows */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 50%, rgba(138,138,138,0.08) 0%, transparent 70%)",
        }}
      />

      {flash && (
        <motion.div
          className="fixed inset-0"
          style={{ zIndex: 200, background: "#000", pointerEvents: "none" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.38 }}
        />
      )}

      <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="overline mb-6 text-gold-bright">Summer 2026</p>

          <h2
            className="section-heading mb-8"
            style={{ fontSize: "clamp(2.8rem, 9vw, 7rem)" }}
          >
            Slots fill up.{" "}
            <br />
            <em
              className="italic"
              style={{
                fontFamily: "'Instrument Serif', 'Fraunces', Georgia, serif",
                background: "var(--gold-gradient)",
                backgroundSize: "200% auto",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                animation: "gold-shimmer 6s linear infinite",
              }}
            >
              Cars don't clean themselves.
            </em>
          </h2>

          <p
            className="text-lg sm:text-xl leading-relaxed max-w-xl mx-auto mb-12"
            style={{ letterSpacing: "-0.01em", color: "#b8b8c0" }}
          >
            Reserve your detail in 90 seconds. Pay nothing today.
          </p>

          <a
            href="/book"
            onClick={handleBook}
            className="inline-flex items-center gap-3 px-9 py-3.5 rounded-full font-medium text-base"
            style={{
              background: "var(--gold)",
              color: "#0b0b0b",
              letterSpacing: "-0.01em",
              textDecoration: "none",
              transition: "all 0.4s cubic-bezier(0.25,0.46,0.45,0.94)",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
              e.currentTarget.style.background = "var(--gold-light)";
              e.currentTarget.style.boxShadow = "0 16px 50px rgba(138,138,138,0.40)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.background = "var(--gold)";
              e.currentTarget.style.boxShadow = "none";
            }}
            data-testid="cta-book-button"
          >
            <span>✦</span> Book a detail
          </a>

          <p
            className="text-sm mt-10"
            style={{ letterSpacing: "0.05em", color: "#9a9aa3" }}
          >
            Average booking takes 90 seconds. No credit card required.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
